import * as style from './Accordion.css';
import { TPoints } from 'shared/types/points';
import { TDeviceType } from '@cian/ui-kit';
import clsx from 'clsx';

interface IAccordionProps {
  items: TPoints[];
  device: TDeviceType;
  Item: React.FC<TPoints>;
}

export const Accordion: React.FC<IAccordionProps> = ({ items, device, Item }) => {
  return (
    <div className={clsx(style['container'], device !== 'desktop' && style['container-tablet'])}>
      {items.map(item => (
        <Item key={item.id} {...item} />
      ))}
    </div>
  );
};
